// Single source of truth for gating unreleased features.
//
// VIDEO_RECORDER_ENABLED — controls the entire gift-recorder + gift-message
// feature set. Until product / legal approval to ship, this MUST stay `false`.
// Flipping it to `true` is the only change required to expose the feature
// across the whole app.
//
// When `false`:
//   • Sender self-record prompt + slot-based recorder (gift-flow step 1) — hidden
//   • Navigation never lands on step1SubStep 3 (prompt) or 4 (recorder)
//   • Contributor "Tell Your Story & Send" tile (gift-flow step 3 upload) — hidden
//   • Contributor occasion picker + recorder modal — hidden
//   • Receiver-side "Tell Your Story" Yes/No prompt screen (gift-content) — skipped
//   • Receiver-side recorder + occasion picker (gift-content) — hidden
//   • GiftMessagePlayer popup (the "play your gift" overlay on gift-content) — hidden
//   • Per-folder "🎁 Open Gift" pills on gift-content folder cards — hidden
//   • Phone-as-webcam (/mobile-camera/:sessionId) — renders an unavailable view
//
// When `true`: everything above is restored to its normal behaviour.
//
// Do NOT add additional conditions for hiding the feature in other places
// without also gating them on this flag — the goal is one switch to rule
// them all so re-enabling is a one-line change.
export const VIDEO_RECORDER_ENABLED = true;
export const VIDEO_RECORDER_COMMENTARY_ENABLED = false;

// GUEST_INVITE_ENABLED — gates the live "Add guest" / meeting feature inside
// the gift recorder, where the host invites a remote person to join the
// recording session over WebRTC (shareable /interview/join link, PIP/side-by-
// side guest tile, active-speaker ring).
//
// When `false`:
//   • The "Add guest" button + connected-guest badge on the recorder stage — hidden
//   • The guest invite-link popup — hidden
//   • The remote-guest PIP overlay — hidden
// The host can still record solo exactly as before; nothing else changes.
//
// This does NOT control the standalone /interview/* pages (intro/host/review),
// which are a separate entry point.
export const GUEST_INVITE_ENABLED = true;

// GIFT_PLAN_CARDS_MOBILE_VERTICAL — controls how the gift plan cards are laid
// out on mobile (≤900px) in the payment step.
//   • true  → cards stack vertically, one below the other (no swipe carousel)
//   • false → original horizontal swipe carousel with dots
// Desktop is unaffected either way. Flip this one line to switch layouts.
export const GIFT_PLAN_CARDS_MOBILE_VERTICAL = true;
